import React from 'react'

const Rat = (props) => (
  <svg viewBox="0 0 45 45" {...props}>
    <defs>
      <clipPath id="a">
        <path d="M0 36h36V0H0v36z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.25 0 0 -1.25 0 45)">
      <path
        d="M30 0H6a1 1 0 1 0 0 2h24c2.542 0 4 1.367 4 3.75C34 7.287 32.357 9 30 9h-7a1 1 0 1 0 0 2h7c3.589 0 6-2.715 6-5.25C36 2.257 33.645 0 30 0"
        fill="#ea596e"
      />

      <path
        d="M12 11.5c0 3.037 3.605 5.937 1 7.5-3.407 2.044-6.879-4.293-9-5-3-1-4-3.407-4-5 0-1.838 1.986-1.725 5-2 1.906-.175 5.594-.125 9-1 2.942-.756-2 2.462-2 5.5"
        fill="#66757f"
      />

      <path
        d="M33 12.5C33 21 29.247 25 24 25c-10 0-14-7-14-14 0-5.247 6.753-6 12-6s11 2.253 11 7.5"
        fill="#66757f"
      />

      <path
        d="M9.781 18.156c0 2.594-2.375 3.22-1.187 5.031.706 1.078 2.587.635 3.051.582-.037-1.332 1.605-1.876 2.054-1.05.378-.37.71-.83.962-1.36.914-1.924-.46-4.49-1.958-5.2-1.496-.712-2.922-.133-2.922 1.997"
        fill="#66757f"
      />

      <path
        d="M13.633 19.86c.084-1.279-.48-2.67-1.396-2.915-.914-.246-1.277.727-1.608 1.961-.33 1.234-.95 2.686-.036 2.932.914.246 2.931-.317 3.04-1.978"
        fill="#e6aaaa"
      />

      <path d="M9 13a1 1 0 1 0-2 0 1 1 0 0 0 2 0" fill="#292f33" />
      <path
        d="M10.594 17.688c-1.26 1.717-2.834 1.977-4.49 1.979-.73 0-.687-.48-.104-.543 1.076-.115 1.963-.405 2.077-.666.076-.175-.702.041-1.431.041-1.167 0-1.041-.297-.167-.52 1.875-.479 1.834-1.22 2.896-1.188 1.063.033 1.219.896 1.219.896m15.848 6.988c-1.65.616-3.942 2.241-6.192 1.991-.75-.083-.462-.518 0-.625.61-.14 1.437-.704 1.731-.932.281-.219-2.314.557-4.065-.109-.872-.332-.514-.563.031-.5.816.093 1.61-.172 2.641-.797s6.931.57 5.854.972"
        fill="#66757f"
      />
    </g>
  </svg>
)

export default Rat
